import { MathUtil } from "@base/math/MathUtil";
import { EdgePositioningMode } from "@biz/definitions/SunSailDefinitions";

export interface IEdgePositionOptions {
  border: number;
  withBorderItems: boolean;
  minDist: number;
}

export class EdgePositioningLogic {
  static calcLenWithoutBorder(sideLen: number, border: number): number {
    return sideLen - border * 2;
  }

  static calcMinSegments(withBorders: boolean): number {
    return withBorders ? 1 : 2;
  }

  static calcMaxSegments(lengthWithoutBorder: number, minDist: number): number {
    return Math.round(lengthWithoutBorder / minDist)
  }

  static calcGrommetsFromSegments(segments: number, withBorderItems: boolean): number {
    return segments + (withBorderItems ? 1 : -1)
  }

  static calcSegmentsFromGrommets(grommets: number, withBorderItems: boolean): number {
    return grommets + (withBorderItems ? -1 : 1)
  }

  static calcCountAndDistFromLength(lengthWithoutBorder: number, distLen: number, options: IEdgePositionOptions): { count: number, dist: number } {
    const segments = MathUtil.clamp(Math.round(lengthWithoutBorder / distLen), EdgePositioningLogic.calcMinSegments(options.withBorderItems), EdgePositioningLogic.calcMaxSegments(lengthWithoutBorder, options.minDist));

    return { dist: lengthWithoutBorder / segments, count: EdgePositioningLogic.calcGrommetsFromSegments(segments, options.withBorderItems) }
  }

  static calcCountAndDistFromPositioning(edgePositioningMode: EdgePositioningMode | undefined, sideLen: number, options: IEdgePositionOptions, params: { userDist?: number; userCount?: number }): { count: number, dist: number } {
    const lengthWithoutBorder = EdgePositioningLogic.calcLenWithoutBorder(sideLen, options.border);
    switch (edgePositioningMode) {
      case "30":
        return EdgePositioningLogic.calcCountAndDistFromLength(lengthWithoutBorder, 0.3, options);
      case "50":
        return EdgePositioningLogic.calcCountAndDistFromLength(lengthWithoutBorder, 0.5, options);
      case "corners":
        return EdgePositioningLogic.calcCountAndDistFromLength(lengthWithoutBorder, lengthWithoutBorder, options)
      case "userDist":
        return EdgePositioningLogic.calcCountAndDistFromLength(lengthWithoutBorder, params.userDist || 10, options);
      case "userCount": {
        const count = params.userCount || 1;
        const segments = MathUtil.clamp(EdgePositioningLogic.calcSegmentsFromGrommets(count, options.withBorderItems), EdgePositioningLogic.calcMinSegments(options.withBorderItems), EdgePositioningLogic.calcMaxSegments(lengthWithoutBorder, options.minDist))
        return { count: EdgePositioningLogic.calcGrommetsFromSegments(segments, options.withBorderItems), dist: lengthWithoutBorder / segments };
      }
    }
    return { count: 0, dist: 0 }
  }

  static calcMaxCount(concaveLength: number, options: IEdgePositionOptions): number {
    const lengthWithoutBorders = EdgePositioningLogic.calcLenWithoutBorder(concaveLength, options.border);
    const maxSegments = EdgePositioningLogic.calcMaxSegments(lengthWithoutBorders, options.minDist);
    return EdgePositioningLogic.calcGrommetsFromSegments(maxSegments, options.withBorderItems);
  }
}